module.exports = __webpack_public_path__ + "static/media/2DGACM1.817d92df.jpg";